
class CompareKeyModel {

    constructor() {
        this.compareKeyId = 0;
        this.compareKeyIndex = 0;
        this.compareKeyName = ""
    }
    getAsJson = () => {
        let obj = {}
        obj.compareKeyId = this.compareKeyId
        obj.compareKeyIndex = this.compareKeyIndex
        obj.compareKeyName=this.compareKeyName
       
        return obj
    }


    initFromJson = (obj) => {
        this.compareKeyId = obj.compareKeyId
        this.compareKeyIndex = obj.compareKeyIndex
        this.compareKeyName = obj.compareKeyName
    }

}
export default CompareKeyModel
